export enum EImages {
    NS = '../../../assets/imgs/NewStudent.png',
    RS = '../../../assets/imgs/RS.JPG',
    CS = '../../../assets/imgs/CS.png',
    AS = '../../../assets/imgs/AS.jpg',
    CGL = '../../../assets/imgs/CGL.png'
}